import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

import { Heading, Flex, Box, Text, Image } from 'rebass';
import Img from 'gatsby-image';
import { LinkBtnTransparent } from './Elements';

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default function TransitionsModal({ img }) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Box onClick={handleOpen} mx="auto" sx={{ cursor: 'pointer' }}>
        <Img fluid={img.fluid} alt={img.alt} />
      </Box>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open} sx={{ margin: '0 auto !important' }}>
          <Box mx="auto" width={['100vw', '90vw']}>
            <Img fluid={img.fluid} alt={img.alt} />
            <Box
              onClick={handleClose}
              py={1}
              color="#fff"
              textAlign="center"
              mb={'-30px'}
              sx={{ cursor: 'pointer' }}
            >
              Sulje
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
